import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getBillingViaPhoneLineNumber = (phoneNumber: string | undefined): Promise<IGetBillingReportViaPhoneNumber[]> => {
  return axiosDefaultApi.get(`/api/Billing/GetDataForPhoneLine/${phoneNumber}`);
};

type QueryFnType = typeof getBillingViaPhoneLineNumber;

type UseGetBillingViaPhoneLineNumberOptions = {
  phoneNumber: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetBillingViaPhoneLineNumber = ({ phoneNumber , config }: UseGetBillingViaPhoneLineNumberOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getBillingViaPhoneLineNumber_${phoneNumber}`],
    queryFn: () => getBillingViaPhoneLineNumber(phoneNumber),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των χρεώσεων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};